var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import ListService from "./Shared/List.service";
import MeetingDependencies from "../../util/meetings/MeetingDependencies";
import SlotDomainService from "../Domain/Slot/Slot.service";
import ServiceDeliveryLocationDomainService from "../Domain/ServiceDeliveryLocation/ServiceDeliveryLocation.service";
import MeetingModalityDomainService from "../Domain/MeetingModality/MeetingModality.service";
const MEETING_AVAILABILITY_URL = "/aviso/meetingAvailability";
export default class MeetingAvailabilityService {
    static search(search = {}) {
        return FetchService.getSingleResponse(MEETING_AVAILABILITY_URL + "/search", {
            personIds: ListService.returnNullIfEmpty(search.personIds),
            serviceOfferingIds: ListService.returnNullIfEmpty(search.serviceOfferingIds),
            locationIds: ListService.returnNullIfEmpty(search.locationIds),
            serviceDeliveryLocationIds: ListService.returnNullIfEmpty(search.serviceDeliveryLocationIds),
        });
    }
    static getDependencyList(campaignId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dependencies = yield FetchService.getSingleResponse(MEETING_AVAILABILITY_URL + "/dependencyList", { campaignId });
            return new MeetingDependencies(dependencies);
        });
    }
    static getSlots(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.postSingleResponse(MEETING_AVAILABILITY_URL + "/slots", Object.assign({ staffIds: options.staffIds, serviceDeliveryLocationIds: options.serviceDeliveryLocationIds, serviceOfferingId: options.serviceOfferingId, meetingModalityIds: options.meetingModalityIds, campusIds: options.campusIds }, ("monthIndex" in options
                ? {
                    month: options.monthIndex,
                    afterDayInMonth: options.afterDayInMonth,
                    year: options.year,
                }
                : { from: options.from, to: options.to })));
            return SlotDomainService.fromJSON({
                slots: resp.slots,
                staff: resp.staff,
                offices: resp.offices.map((o) => ServiceDeliveryLocationDomainService.fromJSON(o)),
                modalities: resp.modalities.map((m) => MeetingModalityDomainService.fromJSON(m)),
            });
        });
    }
    static getStaffAppointmentSettingsForPersonId(personId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(MEETING_AVAILABILITY_URL + "/getStaffAppointmentSettings", {
                personId,
            });
        });
    }
}
